// Import why-did-you-render before React components (when enabled)
// import './wdyr'; // Temporarily disabled due to hooks conflicts

import React from "react";
import { createRoot } from "react-dom/client";
import { routes } from "./app";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router";
import { Auth0Provider } from "@auth0/auth0-react";
import { config } from "./config";
import "./i18n";
import i18n from "./i18n";

declare global {
  interface Window {
    adsbygoogle: { [key: string]: unknown }[];
    aiptag: { [key: string]: unknown }[];
  }
}

// Create the router with our route configuration
const router = createBrowserRouter(routes);

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <Auth0Provider
          domain={config.auth0Domain}
          clientId={config.auth0ClientId}
          authorizationParams={{
            redirect_uri: window.location.origin,
            audience: "franticfanfic.com",
            scope: "openid profile email",
          }}
        >
          <RouterProvider router={router} />
        </Auth0Provider>
      </Provider>
    </React.StrictMode>
  );
}

i18n.loadLanguages("en");
